import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ApiConnectService } from './api-connect.service';
import {
  EmployeeStandardMatrixRequest,
  EmployeeStandardMatrixResponse,
  EmployeeStandardUpdateRequest,
  EmployeeStandardUserResponse
} from '../models/employee-standard-overrides.model';

@Injectable()
export class EmployeeStandardOverridesService {
  constructor(
    private readonly http: HttpClient,
    private readonly apiConnectService: ApiConnectService
  ) {}

  public fetchGroupUsers(groupId: string): Observable<EmployeeStandardUserResponse[]> {
    return this.http.get<EmployeeStandardUserResponse[]>(
      this.createBaseUrl(groupId) + '/users'
    );
  }

  public fetchMatrix(
    groupId: string,
    request: EmployeeStandardMatrixRequest
  ): Observable<EmployeeStandardMatrixResponse> {
    return this.http.post<EmployeeStandardMatrixResponse>(
      this.createBaseUrl(groupId) + '/matrix',
      request
    );
  }

  public updateAssignments(
    groupId: string,
    request: EmployeeStandardUpdateRequest
  ): Observable<string> {
    return this.http.patch(
      this.createBaseUrl(groupId),
      request,
      { responseType: 'text' }
    );
  }

  private createBaseUrl(groupId: string): string {
    return this.apiConnectService.employeeStandardOverrides +
      groupId +
      '/standards/employee-overrides';
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/employee-standard-overrides.service.ts